// src/navigation/Auth/MslConfig/MslConfig.js
//
// PingOne (AccessHub) OIDC configuration for oidc-client-ts / react-oidc-context.
// This file is no longer MSAL-specific; the path/filename is kept as-is from
// the pre-migration Entra ID setup (ASTT-7115) to avoid churning every import
// site for a rename alone.
//
// NOT YET VERIFIED AGAINST A LIVE TOKEN: the exact scope string PingOne
// expects for the ASTT_API resource's RWAccess scope. "RWAccess" mirrors the
// bare scope name used by the old Entra setup (api://.../RWAccess), but
// PingOne resource-scoped custom scopes can sometimes need a different
// format. Confirm the token actually carries the RWAccess scope claim once
// this is running against real PingOne credentials, and adjust
// REACT_APP_OIDC_SCOPE below if not.

import { WebStorageStateStore } from "oidc-client-ts";

export const oidcConfig = {
  authority: process.env.REACT_APP_OIDC_AUTHORITY,
  client_id: process.env.REACT_APP_OIDC_CLIENT_ID,
  redirect_uri: `${window.location.origin}/`,
  post_logout_redirect_uri: `${window.location.origin}/`,
  response_type: "code", // Authorization Code + PKCE. astt-nonprod / astt-spa-prod are public clients — oidc-client-ts uses PKCE automatically, no secret involved.
  scope: process.env.REACT_APP_OIDC_SCOPE || "openid profile email RWAccess",
  // Explicit sessionStorage (oidc-client-ts defaults to localStorage) — same
  // durability as the previous MSAL cacheLocation: "sessionStorage", so a
  // page refresh doesn't force re-login, but nothing here survives closing
  // the tab or leaks into localStorage. A stale token from a decommissioned
  // auth flow can't linger indefinitely the way the pre-migration
  // login-loop bug depended on.
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  automaticSilentRenew: true,
  monitorSession: false,
  loadUserInfo: false,
};